//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapState } from 'vuex'

import TwitchPreFlightCheck from 'core/components/twitch-pre-flight-check.vue'

export default {
    name: 'StreamPreview',

    data() {
        return {
            clip: null,
            blobs: [],
        }
    },

    computed: {
        targetClip() {
            if (!this.showStreamPreview) return null
            return `https://cdn.toonhq.org/streams/previews/${this.stream.preview}`
        },

        ...mapGetters(['showStreamPreview']),
        ...mapState({
            stream: state => state.stream.preview,
            user: state => state.accounts.user,
        }),
    },

    methods: {
        handleClick(e) {
            if (this.stream.preflight) {
                e.preventDefault()
                this.$gtag.event('stream-preview-click')
                this.$present(TwitchPreFlightCheck, { link: this.stream.stream_url })
            } else {
                this.$gtag.event('stream-preview-click-direct')
            }
        },

        ...mapMutations(['hideStreamPreview']),
    },

    created() {
        if (this.targetClip) this.clip = this.targetClip
    },

    watch: {
        targetClip(clip) {
            if (clip && this.clip !== clip) this.clip = this.targetClip
        },

        async clip(url) {
            if (!url) {
                this.blobs.forEach(blob => URL.revokeObjectURL(blob))
                this.blobs = []
                return
            }
            const res = await fetch(url)
            this.blobs.push(URL.createObjectURL(await res.blob()))
            if (this.blobs.length === 1) return
            setTimeout(() => {
                const oldBlob = this.blobs.shift()
                URL.revokeObjectURL(oldBlob)
            }, 1000)
        },
    },
}
